<template>
  <div>
    <component :is="layout"> </component>
    <notify></notify>
  </div>
</template>

<script>
import notify from "@/components/app/notification";
import router from "@/router";
import store from "@/store";
const default_layout = "default";

export default {
  name: "App",

  components: {
    notify,
  },

  computed: {
    layout() {
      return (this.$route.meta.layout || default_layout) + "-layout";
    },
  },

  created() {
    // console.log("App.created()");
  },

  mounted() {
    const scriptWidget = document.createElement("script");
    scriptWidget.id = "roofle.widget";
    scriptWidget.src = "https://app.roofle.com/roof-quote-pro-widget.js?id=NfnDijxebBdDXpjEbHKkg";
    scriptWidget.async = {};
    document.head.appendChild(scriptWidget);
    const scriptEmbedded = document.createElement("script");
    scriptEmbedded.id = "roofle.embedded";
    scriptEmbedded.src = "https://app.roofle.com/roof-quote-pro-embedded-widget.js?id=NfnDijxebBdDXpjEbHKkg";
    scriptEmbedded.async = {};
    document.head.appendChild(scriptEmbedded);
  },

  beforeUnmount() {
    const scriptWidget = document.getElementById("roofle.widget");
    if(scriptWidget) {
      document.head.removeChild(scriptWidget)
    }
    const scriptEmbedded = document.getElementById("roofle.embedded");
    if(scriptEmbedded) {
      document.head.removeChild(scriptEmbedded)
    }
  },

  data: () => ({
    //
  }),

  router,
  store,

  watch: {
  },
};
</script>
<style lang="scss" scoped>
</style>
